import React from "react";

import { PaziaSwitch } from "components/atoms";
import { QUESTION_BASE_FORM_NAMES } from "./BaseQuestionForm";
import { useSurvey } from "pages/SurveyCreate/store/reducer";
import { Question } from "survey";

interface RequiredQuestionFormProps {
  question: Question;
}
export const RequiredQuestionForm = ({ question }: RequiredQuestionFormProps) => {
  const { dispatch } = useSurvey();

  const onChange = (reqVal: boolean) => {
    dispatch({
      type: "UPDATE_QUESTION",
      payload: { ...question, required: reqVal },
    });
  };

  return (
    <>
      <hr className="w-full h-[1px] bg-slate-300 dark:bg-slate-700 border-none my-2" />
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div></div>
        <PaziaSwitch label="Wymagane" name={QUESTION_BASE_FORM_NAMES.REQUIRED} onChange={onChange} />
      </div>
    </>
  );
};
